<app-filter-header title="Filtrar àlies grua" i18n-title  (apply)="this.apply()" (reset)="this.reset()" (dismiss)="this.dismiss()"></app-filter-header>
<div class="modal-body">
  <div class="row">
    <app-filter-text-edit id="grua-alies-filter-alies"class="col-sm-11" i18n-label label="Àlies" [(value)]="filter.descripcio" contains></app-filter-text-edit>
  </div>
</div>
